// @flow

import * as React from "react";
import DataFetcher from "buba-components/src/components/DataFetcher";
import { Section, Card, Preloader } from "buba-components";
import { denormalizeJsonApi } from "buba-components/src/utils/denormalizeJsonApi";
import { getBankHints } from "../../api/actions";

import BankHints from "./BankHints";

type BankHintsWrapperProps = {
  inquiryId: number
};

const BankHintsWrapper = ({ inquiryId }: BankHintsWrapperProps) => (
  <DataFetcher
    apiAction={getBankHints}
    mapper={denormalizeJsonApi}
    initialPayload={{ id: inquiryId }}
  >
    {({ data, isLoading }) => (
      <Section title="Kommunikation" numbered reducedMargin>
        <Card>
          <header>Hinweise von der Bürgschaftsbank</header>

          {isLoading ? <Preloader /> : data && <BankHints bankHints={data} />}
        </Card>
      </Section>
    )}
  </DataFetcher>
);

BankHintsWrapper.defaultProps = {
  inquiryId: null
};

export default BankHintsWrapper;
